import type { ResponseError, UsersResponse } from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../../use-rendall-api';

type Options<T> = Omit<
  UseQueryOptions<UsersResponse, ResponseError, T>,
  'queryKey' | 'queryFn'
>;

export const getGetUsersListKey = (organizationId: string) => [
  organizationId,
  'rendall',
  'get-users-list',
];

export const useGetUsersList = <T = UsersResponse>(options?: Options<T>) => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();

  return useQuery({
    queryFn: () =>
      api.getUsersList({
        organizationId: selectedOrganization.id,
      }),
    queryKey: getGetUsersListKey(selectedOrganization.id),
    refetchOnMount: false,
    staleTime: 1000 * 60 * 5,
    ...options,
  });
};
